module.exports = __webpack_public_path__ + "assets/img/s1_chart-1.3f400d3f.png";